import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { DOTCOM_UX_ID } from '@nike/ux-tread-dotcom-constants';
import selectDefaultListId from './select';
import getMarketplace from "../../../../global-config/get-marketplace";
import getWishlistQueryKey from "../get-query-key";
export var fetchDefaultList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var marketplace, token;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return getMarketplace();
        case 1:
          marketplace = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getAccessToken();
        case 2:
          token = _context.sent;
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/wishlists/v2/lists?marketplace=").concat(marketplace, "&isDefault=true"),
          // hardcoding to default list only
          {
            method: 'GET',
            credentials: 'include',
            headers: formatHeaders({
              token: token,
              appId: DOTCOM_UX_ID
            })
          }, 'Error getting default list.'));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchDefaultList() {
    return _ref.apply(this, arguments);
  };
}();
var getFetchDefaultListOptions = function getFetchDefaultListOptions() {
  return {
    queryKey: getWishlistQueryKey(),
    queryFn: function () {
      var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return fetchDefaultList();
            case 1:
              return _context2.abrupt("return", _context2.sent);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function queryFn() {
        return _queryFn.apply(this, arguments);
      }
      return queryFn;
    }(),
    staleTime: Infinity
  };
};
export default getFetchDefaultListOptions;
export var getDefaultListId = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
    var queryClient, _t, _t2, _t3, _t4;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          queryClient = _ref2.queryClient;
          _t = selectDefaultListId;
          _t2 = queryClient;
          _t3 = getFetchDefaultListOptions;
          _context3.next = 1;
          return window.webShellClient.identity.getIsLoggedIn();
        case 1:
          _t4 = _context3.sent;
          _context3.next = 2;
          return _t2.fetchQuery.call(_t2, _t3({
            isLoggedIn: _t4
          }));
        case 2:
          return _context3.abrupt("return", _t(_context3.sent));
        case 3:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getDefaultListId(_x) {
    return _ref3.apply(this, arguments);
  };
}();